import React from 'react';
import {
  Grid,
  Divider,
  makeStyles,
  colors,
  CircularProgress,
  Button,
} from '@material-ui/core';
import { Save } from '@material-ui/icons';

import Description from 'components/typography/Description';
import RecipeMenu from 'components/recipes/menu/RecipesMenu';

const useStyles = makeStyles({
  description: {
    color: colors.red[900],
  },
  saveButton: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const RecipeEditMenu = ({
  recipeContent,
  router,
  showEditWarning = false,
  onSaveButtonClick,
  isLoading,
}) => {
  return (
    <Grid container direction="column" spacing={4}>
      {showEditWarning && (
        <Grid item>
          <EditWarning
            onSaveButtonClick={onSaveButtonClick}
            isLoading={isLoading}
          ></EditWarning>
        </Grid>
      )}

      <Grid item>
        <RecipeMenu router={router} recipe={recipeContent}></RecipeMenu>
      </Grid>
    </Grid>
  );
};

const EditWarning = ({ onSaveButtonClick, isLoading }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item container alignItems="center">
        <Grid item style={{ flexGrow: 1 }}>
          <Description>
            <b>
              <i className={classes.description}>You unsaved changes</i>
            </b>
          </Description>
        </Grid>

        <Grid item>
          <Button
            onClick={onSaveButtonClick}
            className={classes.saveButton}
            startIcon={
              isLoading ? (
                <CircularProgress
                  style={{ color: colors.red[400] }}
                  size={20}
                ></CircularProgress>
              ) : (
                <Save></Save>
              )
            }
          >
            SAVE
          </Button>
        </Grid>
      </Grid>

      <Grid item>
        <Divider></Divider>
      </Grid>
    </Grid>
  );
};

export default RecipeEditMenu;
